<div class="w-full relative" #container tabindex="0">
  <label *ngIf="label" class="text-sm font-medium text-gray-700">
    {{ label }}
    <span *ngIf="isRequired" class="text-red-500 cursor-help relative group">
      *
      <span
        class="absolute left-0 bottom-full mb-1 w-max px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200"
      >
        Este campo es obligatorio
      </span>
    </span>
  </label>
  <div class="relative flex items-center">
    <input
      type="text"
      [placeholder]="selectedOptionLabel || placeholder"
      [formControl]="searchTerm"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [disabled]="disabled"
      [ngClass]="{
        'cursor-not-allowed bg-gray-100 text-gray-500': disabled
      }"
      class="w-full px-4 py-2 border text-gray-800 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary transition duration-150 ease-in-out cursor-pointer"
    />
    <span
      class="absolute inset-y-0 right-0 flex items-center pr-3 bg-white border-r border-t border-b border-gray-200 rounded-tr-md rounded-br-md"
      tabindex="-1"
    >
      <ng-icon
        name="heroChevronDown"
        size="20"
        class="text-gray-500 transition-transform duration-200"
        [ngClass]="{ 'rotate-180': isOpen }"
      ></ng-icon>
    </span>
  </div>
  <div
    *ngIf="isOpen"
    class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg overflow-hidden"
    [ngClass]="{
      'bottom-full mb-1': deployUp,
      'top-full mt-1': !deployUp
    }"
  >
    <div
      *ngIf="showPreview"
      class="p-3 text-center text-gray-500 text-sm border-b border-gray-100"
    >
      Buscar
    </div>
    <ul class="max-h-64 overflow-y-auto">
      <li
        *ngIf="filteredOptions.length === 0"
        class="px-4 py-2 text-gray-500 text-sm"
      >
        No se encontraron resultados.
      </li>
      <li
        *ngFor="let opt of filteredOptions"
        (click)="selectOption(opt)"
        class="px-4 py-2 cursor-pointer hover:bg-primary/10 text-gray-800 text-sm truncate"
        [ngClass]="{
          'bg-primary/10 text-primary font-medium':
            opt.value === formControl.value
        }"
      >
        {{ opt.label }}
      </li>
    </ul>
  </div>
  <app-show-error
    *ngIf="showError"
    [control]="control"
    [fieldName]="normalizedFieldName"
  >
  </app-show-error>
</div>
